import { showSnackbar } from '../../store/Snackbar/snackbar.actions';
import Button from 'material-ui/Button';
import { getCdnUrl } from '../../utils/cdn';
import { MediaItem } from '../../store/Entities/Media/media.reducer';
import Grid from 'material-ui/Grid';
import * as React from 'react';
import { connect } from 'react-redux';
import ListToolbar from '../../components/ListToolbar';
import MediaDropzone from '../../modules/MediaDropzone';
import {
  default as S3MediaDropzone,
  S3Result,
} from '../../modules/S3MediaDropzone';
import * as CopyToClipboard from 'react-copy-to-clipboard';
import { getVideoUrl } from '../../utils/url';
import { isEmpty } from 'ramda';

interface State {
  image?: MediaItem;
  video?: S3Result;
}

type Props = typeof mapeDispatchToProps;
class MediaUpload extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      image: void 0,
      video: void 0,
    };
  }

  private imageUploaded = (mediaItem: MediaItem) => {
    this.setState({ image: mediaItem });
  };

  private videoUploaded = (result: S3Result) => {
    this.setState({ video: result });
  };

  private linkCopied = (text: string) => {
    const { onShowMessage } = this.props;

    if (text) {
      onShowMessage({ message: 'URL copied', type: 'success' });
    } else {
      onShowMessage({ message: 'Could not copy URL', type: 'error' });
    }
  };

  private renderImageInfo = () => {
    const { image } = this.state;

    if (!image) {
      return null;
    }

    const url = getCdnUrl(image.hash);

    return (
      <div style={{ marginTop: 15 }}>
        <CopyToClipboard text={url} onCopy={this.linkCopied}>
          <Button style={{ backgroundColor: '#e1f694', color: '#253238' }}>
            Copy to clipboard
          </Button>
        </CopyToClipboard>

        <p style={{ marginTop: 15 }}>
          <a
            href={url}
            target="_blank"
            rel="noopener"
            style={{ color: '#ffff8c' }}
          >
            {url}
          </a>
        </p>
      </div>
    );
  };

  private renderVideoInfo = () => {
    const { video } = this.state;
    if (!video) {
      return null;
    }

    const url = getVideoUrl(video);

    if (isEmpty(url)) {
      return null;
    }

    return (
      <div style={{ marginTop: 15 }}>
        <CopyToClipboard text={url} onCopy={this.linkCopied}>
          <Button
            style={{
              backgroundColor: '#e1f694',
              color: '#253238',
            }}
          >
            Copy to clipboard
          </Button>
        </CopyToClipboard>

        <p style={{ marginTop: 15 }}>
          <a
            href={url}
            target="_blank"
            rel="noopener"
            style={{ color: '#ffff8c' }}
          >
            {url}
          </a>
        </p>
      </div>
    );
  };

  public render() {
    return (
      <div>
        <ListToolbar />
        <Grid
          container={true}
          justify="center"
          direction="column"
          style={{
            marginTop: 102,
            marginLeft: 60,
            marginRight: 60,
            marginBottom: 60,
            color: '#fff',
          }}
        >
          <Grid item={true} style={{ maxWidth: 500 }}>
            <h3>Upload an image</h3>
            <MediaDropzone
              zoneId="image-upload"
              onUploaded={this.imageUploaded}
              height={300}
            />
            {this.renderImageInfo()}
          </Grid>
          <Grid item={true} style={{ width: 500 }}>
            <h3>Upload a video</h3>
            <S3MediaDropzone onFileUploaded={this.videoUploaded} />
            {this.renderVideoInfo()}
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapeDispatchToProps = { onShowMessage: showSnackbar };

export default connect(
  undefined,
  mapeDispatchToProps
)(MediaUpload);



// WEBPACK FOOTER //
// ./src/modules/MediaUpload/index.tsx